function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { getTemplate, getUiOptions, orderProperties, TranslatableString, ADDITIONAL_PROPERTY_FLAG, PROPERTIES_KEY, REF_KEY, ANY_OF_KEY, ONE_OF_KEY } from '@rjsf/utils';
import Markdown from 'markdown-to-jsx';
import get from 'lodash/get';
import has from 'lodash/has';
import isObject from 'lodash/isObject';
import set from 'lodash/set';
import unset from 'lodash/unset';
/** The `ObjectField` component is used to render a field in the schema that is of type `object`. It tracks whether an
 * additional property key was modified and what it was modified to
 *
 * @param props - The `FieldProps` for this template
 */

var ObjectField = /*#__PURE__*/function (_Component) {
  _inherits(ObjectField, _Component);

  var _super = _createSuper(ObjectField);

  function ObjectField() {
    var _this;

    _classCallCheck(this, ObjectField);

    _this = _super.apply(this, arguments);
    /** Set up the initial state */

    _this.state = {
      wasPropertyKeyModified: false,
      additionalProperties: {}
    };
    /** Returns the `onPropertyChange` handler for the `name` field. Handles the special case where a user is attempting
     * to clear the data for a field added as an additional property. Calls the `onChange()` handler with the updated
     * formData.
     *
     * @param name - The name of the property
     * @param addedByAdditionalProperties - Flag indicating whether this property is an additional property
     * @returns - The onPropertyChange callback for the `name` property
     */

    _this.onPropertyChange = function (name) {
      var addedByAdditionalProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return function (value, newErrorSchema, id) {
        var _this$props = _this.props,
            formData = _this$props.formData,
            onChange = _this$props.onChange,
            errorSchema = _this$props.errorSchema;

        if (value === undefined && addedByAdditionalProperties) {
          // Don't set value = undefined for fields added by
          // additionalProperties. Doing so removes them from the
          // formData, which causes them to completely disappear
          // (including the input field for the property name). Unlike
          // fields which are "mandated" by the schema, these fields can
          // be set to undefined by clicking a "delete field" button, so
          // set empty values to the empty string.
          value = '';
        }

        var newFormData = _objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, name, value));

        onChange(newFormData, errorSchema && errorSchema && _objectSpread(_objectSpread({}, errorSchema), {}, _defineProperty({}, name, newErrorSchema)), id);
      };
    };
    /** Returns a callback to handle the onDropPropertyClick event for the given `key` which removes the old `key` data
     * and calls the `onChange` callback with it
     *
     * @param key - The key for which the drop callback is desired
     * @returns - The drop property click callback
     */


    _this.onDropPropertyClick = function (key) {
      return function (event) {
        event.preventDefault();
        var _this$props2 = _this.props,
            onChange = _this$props2.onChange,
            formData = _this$props2.formData;

        var copiedFormData = _objectSpread({}, formData);

        unset(copiedFormData, key);
        onChange(copiedFormData);
      };
    };
    /** Computes the next available key name from the `preferredKey`, indexing through the already existing keys until one
     * that is already not assigned is found.
     *
     * @param preferredKey - The preferred name of a new key
     * @param [formData] - The form data in which to check if the desired key already exists
     * @returns - The name of the next available key from `preferredKey`
     */


    _this.getAvailableKey = function (preferredKey, formData) {
      var _this$props3 = _this.props,
          uiSchema = _this$props3.uiSchema,
          registry = _this$props3.registry;

      var _getUiOptions = getUiOptions(uiSchema, registry.globalUiOptions),
          _getUiOptions$duplica = _getUiOptions.duplicateKeySuffixSeparator,
          duplicateKeySuffixSeparator = _getUiOptions$duplica === void 0 ? '-' : _getUiOptions$duplica;

      var index = 0;
      var newKey = preferredKey;

      while (has(formData, newKey)) {
        newKey = "".concat(preferredKey).concat(duplicateKeySuffixSeparator).concat(++index);
      }

      return newKey;
    };
    /** Returns a callback function that deals with the rename of a key for an additional property for a schema. That
     * callback will attempt to rename the key and move the existing data to that key, calling `onChange` when it does.
     *
     * @param oldValue - The old value of a field
     * @returns - The key change callback function
     */


    _this.onKeyChange = function (oldValue) {
      return function (value, newErrorSchema) {
        if (oldValue === value) {
          return;
        }

        var _this$props4 = _this.props,
            formData = _this$props4.formData,
            onChange = _this$props4.onChange,
            errorSchema = _this$props4.errorSchema;
        value = _this.getAvailableKey(value, formData);

        var newFormData = _objectSpread({}, formData);

        var newKeys = _defineProperty({}, oldValue, value);

        var keyValues = Object.keys(newFormData).map(function (key) {
          var newKey = newKeys[key] || key;
          return _defineProperty({}, newKey, newFormData[key]);
        });
        var renamedObj = Object.assign.apply(Object, [{}].concat(_toConsumableArray(keyValues)));

        _this.setState({
          wasPropertyKeyModified: true
        });

        onChange(renamedObj, errorSchema && errorSchema && _objectSpread(_objectSpread({}, errorSchema), {}, _defineProperty({}, value, newErrorSchema)));
      };
    };
    /** Handles the adding of a new additional property on the given `schema`. Calls the `onChange` callback once the new
     * default data for that field has been added to the formData.
     *
     * @param schema - The schema element to which the new property is being added
     */


    _this.handleAddClick = function (schema) {
      return function () {
        var _a;

        if (!schema.additionalProperties) {
          return;
        }

        var _this$props5 = _this.props,
            formData = _this$props5.formData,
            onChange = _this$props5.onChange,
            registry = _this$props5.registry;

        var newFormData = _objectSpread({}, formData);

        var type = undefined;
        var constValue = undefined;
        var defaultValue = undefined;

        if (isObject(schema.additionalProperties)) {
          type = schema.additionalProperties.type;
          constValue = schema.additionalProperties.const;
          defaultValue = schema.additionalProperties.default;
          var apSchema = schema.additionalProperties;

          if (REF_KEY in apSchema) {
            var schemaUtils = registry.schemaUtils;
            apSchema = schemaUtils.retrieveSchema({
              $ref: apSchema[REF_KEY]
            }, formData);
            type = apSchema.type;
            constValue = apSchema.const;
            defaultValue = apSchema.default;
          }

          if (!type && (ANY_OF_KEY in apSchema || ONE_OF_KEY in apSchema)) {
            type = 'object';
          }
        }

        var newKey = _this.getAvailableKey('newKey', newFormData);

        var newValue = (_a = constValue !== null && constValue !== void 0 ? constValue : defaultValue) !== null && _a !== void 0 ? _a : _this.getDefaultValue(type); // Cast this to make the `set` work properly

        set(newFormData, newKey, newValue);
        onChange(newFormData);
      };
    };

    return _this;
  }
  /** Returns a flag indicating whether the `name` field is required in the object schema
   *
   * @param name - The name of the field to check for required-ness
   * @returns - True if the field `name` is required, false otherwise
   */


  _createClass(ObjectField, [{
    key: "isRequired",
    value: function isRequired(name) {
      var schema = this.props.schema;
      return Array.isArray(schema.required) && schema.required.indexOf(name) !== -1;
    }
    /** Returns a default value to be used for a new additional schema property of the given `type`
     *
     * @param type - The type of the new additional schema property
     */

  }, {
    key: "getDefaultValue",
    value: function getDefaultValue(type) {
      var translateString = this.props.registry.translateString;

      switch (type) {
        case 'array':
          return [];

        case 'boolean':
          return false;

        case 'null':
          return null;

        case 'number':
          return 0;

        case 'object':
          return {};

        case 'string':
        default:
          // We don't have a datatype for some reason (perhaps additionalProperties was true)
          return translateString(TranslatableString.NewStringDefault);
      }
    }
    /** Renders the `ObjectField` from the given props
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a, _b, _c, _d;

      var _this$props6 = this.props,
          rawSchema = _this$props6.schema,
          _this$props6$uiSchema = _this$props6.uiSchema,
          uiSchema = _this$props6$uiSchema === void 0 ? {} : _this$props6$uiSchema,
          formData = _this$props6.formData,
          errorSchema = _this$props6.errorSchema,
          idSchema = _this$props6.idSchema,
          name = _this$props6.name,
          _this$props6$required = _this$props6.required,
          required = _this$props6$required === void 0 ? false : _this$props6$required,
          disabled = _this$props6.disabled,
          readonly = _this$props6.readonly,
          hideError = _this$props6.hideError,
          idPrefix = _this$props6.idPrefix,
          idSeparator = _this$props6.idSeparator,
          onBlur = _this$props6.onBlur,
          onFocus = _this$props6.onFocus,
          registry = _this$props6.registry,
          title = _this$props6.title;
      var fields = registry.fields,
          formContext = registry.formContext,
          schemaUtils = registry.schemaUtils,
          translateString = registry.translateString,
          globalUiOptions = registry.globalUiOptions;
      var SchemaField = fields.SchemaField;
      var schema = schemaUtils.retrieveSchema(rawSchema, formData);
      var uiOptions = getUiOptions(uiSchema, globalUiOptions);
      var _schema$properties = schema.properties,
          schemaProperties = _schema$properties === void 0 ? {} : _schema$properties;
      var templateTitle = (_c = (_b = (_a = uiOptions.title) !== null && _a !== void 0 ? _a : schema.title) !== null && _b !== void 0 ? _b : title) !== null && _c !== void 0 ? _c : name;
      var description = (_d = uiOptions.description) !== null && _d !== void 0 ? _d : schema.description;
      var orderedProperties;

      try {
        var properties = Object.keys(schemaProperties);
        orderedProperties = orderProperties(properties, uiOptions.order);
      } catch (err) {
        return _jsxs("div", {
          children: [_jsx("p", {
            className: 'config-error',
            style: {
              color: 'red'
            },
            children: _jsx(Markdown, {
              options: {
                disableParsingRawHTML: true
              },
              children: translateString(TranslatableString.InvalidObjectField, [name || 'root', err.message])
            })
          }), _jsx("pre", {
            children: JSON.stringify(schema)
          })]
        });
      }

      var Template = getTemplate('ObjectFieldTemplate', registry, uiOptions);
      var templateProps = {
        // getDisplayLabel() always returns false for object types, so just check the `uiOptions.label`
        title: uiOptions.label === false ? '' : templateTitle,
        description: uiOptions.label === false ? undefined : description,
        properties: orderedProperties.map(function (name) {
          var addedByAdditionalProperties = has(schema, [PROPERTIES_KEY, name, ADDITIONAL_PROPERTY_FLAG]);
          var fieldUiSchema = addedByAdditionalProperties ? uiSchema.additionalProperties : uiSchema[name];
          var hidden = getUiOptions(fieldUiSchema).widget === 'hidden';
          var fieldIdSchema = get(idSchema, [name], {});
          return {
            content: _jsx(SchemaField, {
              name: name,
              required: _this2.isRequired(name),
              schema: get(schema, [PROPERTIES_KEY, name], {}),
              uiSchema: fieldUiSchema,
              errorSchema: get(errorSchema, name),
              idSchema: fieldIdSchema,
              idPrefix: idPrefix,
              idSeparator: idSeparator,
              formData: get(formData, name),
              formContext: formContext,
              wasPropertyKeyModified: _this2.state.wasPropertyKeyModified,
              onKeyChange: _this2.onKeyChange(name),
              onChange: _this2.onPropertyChange(name, addedByAdditionalProperties),
              onBlur: onBlur,
              onFocus: onFocus,
              registry: registry,
              disabled: disabled,
              readonly: readonly,
              hideError: hideError,
              onDropPropertyClick: _this2.onDropPropertyClick
            }, name),
            name: name,
            readonly: readonly,
            disabled: disabled,
            required: required,
            hidden: hidden
          };
        }),
        readonly: readonly,
        disabled: disabled,
        required: required,
        idSchema: idSchema,
        uiSchema: uiSchema,
        errorSchema: errorSchema,
        schema: schema,
        formData: formData,
        formContext: formContext,
        registry: registry
      };
      return _jsx(Template, _objectSpread(_objectSpread({}, templateProps), {}, {
        onAddClick: this.handleAddClick
      }));
    }
  }]);

  return ObjectField;
}(Component);

export default ObjectField;